import {getBffClient, getBffClients, getBffSalespartner, SalespartnerInterface} from "@prowin/salespartner-client";
import {Logger} from "@prowin/logger";
import {BFFOAuthClient} from "@prowin/bff-oauth-client";

export function loadSalespartner(oauth: BFFOAuthClient): Promise<SalespartnerInterface | null> {

    Logger.setPrefix("Salespartner");

    if (oauth.initialized) {
        if (oauth.hasOwnProperty('user') && oauth.user.hasOwnProperty('id')) {
            return getBffSalespartner(parseInt(oauth.user.id), oauth.api.bind(oauth))
                .then( salespartner => {
                    return Promise.all([getBffClient(salespartner.client, oauth.api.bind(oauth)), getBffClients(oauth.api.bind(oauth))]).then( ([clientData, clients ]) => {
                        salespartner.clientData = clientData;
                        salespartner.clients = clients;
                        return salespartner;
                    })
                });
        } else {
            return Promise.resolve(null)
        } // if else

    } else {
        return Promise.resolve(null)
    } // if else

} // loadSalespartner

